import LoaderSVG from '@public/icons/loader.svg';
import { AnimatePresence, m as motion } from 'framer-motion';
import React from 'react';

interface Props {
    isFetching: boolean;
    noAnimationOnStart?: boolean;
}

function Loader({ isFetching, noAnimationOnStart = false }: Props) {
    return (
        <AnimatePresence mode="wait">
            {isFetching && (
                <motion.div
                    className="loader-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: noAnimationOnStart ? 0 : 0.6 } }}
                    exit={{ opacity: 0, transition: { duration: 0.6 } }}
                >
                    <LoaderSVG />
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export default Loader;
